import * as React from 'react'
import autobind from 'autobind-decorator'
import {withTranslation, WithTranslation} from 'react-i18next'
import {DatePicker, Switch} from 'antd'
import moment from 'moment';
import {RangePickerValue} from 'antd/lib/date-picker/interface';

const { RangePicker } = DatePicker;


interface RangeDatePickerFilterProps extends WithTranslation {
    onChange?: (dates: RangePickerValue) => void,
    format?: string;
    disableDate?: any;
    initDates?: RangePickerValue, 
    initalShowDates?: boolean;
}

interface RangeDatePickerFilterState {
    dates: RangePickerValue;
    format: string;
    showDates: boolean;
}

class RangePickerFilter extends React.Component<RangeDatePickerFilterProps, RangeDatePickerFilterState> {

    constructor(props: RangeDatePickerFilterProps) {
        super(props);
        this.state = {
            dates: props.initDates ?? this.getCurrentWeek() as any,
            format: props.format || 'DD-MM-YYYY',
            showDates: props.initalShowDates ?? false
        }
    }

    @autobind
    onChange(dates: RangePickerValue) {
        this.setState({ dates })
        if (this.props.onChange && this.state.showDates) {
            this.props.onChange(dates);
        }
    }

    @autobind
    onClickButton() {
        if (this.props.onChange)
            this.props.onChange(this.state.dates)
    }

    getCurrentWeek() {
        var currentDate = moment();
        var weekStart = currentDate.clone().startOf('week');
        var weekEnd = currentDate.clone().endOf('week');
        return [weekStart, weekEnd];
    }

    onShowFilterChange() {
        this.setState({ showDates: !this.state.showDates })
        if (this.state.showDates) {
            if (this.props.onChange)
                this.props.onChange([])
        }
            else {
            if (this.props.onChange)
                this.props.onChange(this.state.dates)
            }
        }



    public render() {
      
        var { t } = this.props;
        return (<>
            <span className={"customSwitch-title"}>{t('Filter by date?')}</span>
            <Switch className={"customSwitch"} checked={this.state.showDates} onChange={(value) => this.onShowFilterChange()}></Switch>
            {this.state.showDates && < RangePicker onPanelChange={(value) => { }} format={this.state.format} onChange={this.onChange} defaultValue={this.props.initDates ? this.props.initDates : this.getCurrentWeek() as any} placeholder={[t('Start Date'), t('End Date')]} disabledDate={this.props.disableDate} />}      
            </>);
    }
}

export default withTranslation()(RangePickerFilter);